
import makerjs from "makerjs";
/**
 * 计算两点间的弦长
 * @param {Object} p1 - 第一个点坐标 {x, y}
 * @param {Object} p2 - 第二个点坐标 {x, y}
 * @returns {number} 弦长值
 */
 function calculateChordLength(p1, p2) {
  const dx = p2.x - p1.x;
  const dy = p2.y - p1.y;
  return Math.sqrt(dx*dx + dy*dy);
}
//已知劣弧上两点坐标及半径，求圆心坐标劣弧中心点坐标。
function optimizedArcMidpoint(start, end, radius) {
  // 1. 预计算差值避免重复计算
  const dx = end.x - start.x;
  const dy = end.y - start.y;
  const dSquared = dx * dx + dy * dy;

  // 快速检查半径有效性
  if (dSquared > 4 * radius * radius) return null; // 使用平方比较避免开方运算

  // 2. 计算中点（仅需一次加法运算）
  const midX = (start.x + end.x) * 0.5;
  const midY = (start.y + end.y) * 0.5;

  // 3. 计算垂直向量（优化单位化过程）
  const invD = 1 / Math.sqrt(dSquared);
  const ux = dy * invD;  // 单位垂直向量x分量
  const uy = -dx * invD; // 单位垂直向量y分量

  // 4. 计算圆心（单解模式，直接选择劣弧圆心）
  const h = Math.sqrt(radius * radius - dSquared * 0.25);
  const center = {
    x: midX + h * ux,
    y: midY + h * uy
  };

  // 5. 向量法计算中点（优化单位化过程）
  const v1x = start.x - center.x;
  const v1y = start.y - center.y;
  const v2x = end.x - center.x;
  const v2y = end.y - center.y;

  // 单位向量相加
  const sumX = v1x + v2x;
  const sumY = v1y + v2y;
  const invLen = radius / Math.sqrt(sumX * sumX + sumY * sumY);

  return {
    x: center.x + sumX * invLen,
    y: center.y + sumY * invLen
  };
}
function C14(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
    W = Param[0].param, H = Param[1].param, W1 = Param[2].param,  S= Param[3].param,
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    h = H * 1 * myZoom,
    w1 = W1 * 1 * myZoom,
    s = S * 1 * myZoom,
    w = W * 1 * myZoom,
    // x0 = X*1*myZoom,
    // y0 = Y*1*myZoom;
    x0 = 0, x1 = w1, x2 = w, y0 = 0, y1 = h, y2 = 0, glassH = h, glassW = w;
    const p1 = { x: x0, y: y0 };
    const p2 = { x: x1, y: y1 };
    // const arcLength=h2;
    var L=calculateChordLength(p1, p2);
    // L：弦长（两点间距离）
    // h：拱高（弦中心点到弧的垂直距离）
    var r = (L*L + 4*s*s)/(8*s);
    // var r=calculateRadius(p1, p2, arcLength);
  const start = { x: x0, y: y0 };
  const end = { x: x1, y: y1 };
  const radius = r;
  // const midpoint = calculateArcMidpoint(start, end, radius);
  const midpoint = optimizedArcMidpoint(start, end, radius);
  console.log("输出劣弧中点坐标start=", start); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标end=", end); // 输出劣弧中点坐标
  console.log("输出劣弧中点坐标=", midpoint); // 输出劣弧中点坐标
  //  var aa=Circle_Center(x1,y1,x2,y2,r);
  //  console.log("aa====",aa);
  var xm = midpoint.x, ym = midpoint.y;

  console.log("输出劣弧中点坐标xm,ym=", xm, ym); // 输出劣弧中点坐标

  //计算中点坐标
  const mx = (x1 + x0) / 2;
  const my = (y1 + y0) / 2;

  if (h !== 0) {
    var TxtH = H;
  } if (w1 !== 0) {
    var TxtW1 = W1;
  } if (s !== 0) {
    var TxtS = "S=" + S;
  }
  if (w !== 0) {
    var TxtW = W;
  }



  var drawAbnormalShapeC14 = {
    paths: {
      "ArcLine": new makerjs.paths.Arc([x0, y0], [x1, y1], r, false, true),
      "RightLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
      "BottomLine": new makerjs.paths.Line([x2, y2], [x0, y0]),
    }
  };
  var drawAbnormalShapeC14MarkH = {
    paths: {
      "LeftLine": new makerjs.paths.Line([x0 - markShift, y0], [x0 - markShift, y1]),
      "LeftShortUpline": new makerjs.paths.Line([x1, y1], [x0 - 2 * markShift, y1]),
      "LeftShortDnline": new makerjs.paths.Line([x0, y0], [x0 - 2 * markShift, y0]),
    }
  };
  var drawAbnormalShapeC14MarkS = {
    paths: {
      "LeftLine": new makerjs.paths.Line([xm, ym], [mx, my]),
    }
  };
  var drawAbnormalShapeC14MarkW1 = {
    paths: {
      "UpLine": new makerjs.paths.Line([x0, y1 + markShift], [x1, y1 + markShift]),
      "UpShortLfline": new makerjs.paths.Line([x0, y1], [x0, y1 + 2 * markShift]),
      "UpShortRTline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
    }
  };
  var drawAbnormalShapeC14MarkW = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x2, y2 - markShift]),
      "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
    }
    //  };

  };
  makerjs.model.addCaption(drawAbnormalShapeC14MarkW, TxtW, [x0, y0 - 2 * markShift], [x2, y2 - 2 * markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC14MarkW1, TxtW1, [x0, y1 + 2 * markShift], [x1, y1 + 2 * markShift]);//长度文字
  makerjs.model.addCaption(drawAbnormalShapeC14MarkH, TxtH, [x0 - 2 * markShift, y0], [x0 - 2 * markShift, y1]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC14MarkS, TxtS, [mx + markShift, my- 2*markShift], [mx + 3 * markShift, my- 2*markShift]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC14: drawAbnormalShapeC14,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC14: drawAbnormalShapeC14,
      drawAbnormalShapeC14MarkW1: drawAbnormalShapeC14MarkW1,
      drawAbnormalShapeC14MarkS: drawAbnormalShapeC14MarkS,
      drawAbnormalShapeC14MarkH: drawAbnormalShapeC14MarkH,
      drawAbnormalShapeC14MarkW: drawAbnormalShapeC14MarkW
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C14;